export const LOAD = 'binary/location/LOAD';
export const LOAD_SUCCESS = 'binary/location/LOAD_SUCCESS';
export const LOAD_FAIL = 'binary/client/LOAD_FAIL';

export function loadLocations(clientId) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],

    payload: {
      client: 'nextgen',
      request: {
        method: 'get',
        url: '/api/entity/' + clientId + '/list'
      }
    }
  };
}
